import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/WorkSection.css";
import logo1  from "../assets/logos/logo1.jpeg";
import logo2  from "../assets/logos/logo2.jpeg";
import logo3  from "../assets/logos/logo3.jpeg";
import logo4  from "../assets/logos/logo4.jpeg";
import logo5  from "../assets/logos/logo5.jpeg";
import logo6  from "../assets/logos/logo6.jpeg";
import logo7  from "../assets/logos/logo7.jpeg";
import logo8  from "../assets/logos/logo8.jpeg";
import logo9  from "../assets/logos/logo9.jpeg";
import logo10 from "../assets/logos/logo10.jpeg";
import logo11 from "../assets/logos/logo11.jpeg";
import logo12 from "../assets/logos/logo12.jpeg";
import logo13 from "../assets/logos/logo13.jpeg";
import logo14 from "../assets/logos/logo14.jpeg";
import logo15 from "../assets/logos/logo15.jpeg";
import logo16 from "../assets/logos/logo16.jpeg";
import logo17 from "../assets/logos/logo17.jpeg";
import logo18 from "../assets/logos/logo18.jpeg";
import logo19 from "../assets/logos/logo19.jpeg";
import logo20 from "../assets/logos/logo20.jpeg";
import logo21 from "../assets/logos/logo21.jpeg";

const LOGOS = [
  logo1, logo2, logo3, logo4, logo5, logo6, logo7,
  logo8, logo9, logo10, logo11, logo12, logo13, logo14,
  logo15, logo16, logo17, logo18, logo19, logo20, logo21,
];

export default function WorkSection() {
  const { t } = useTranslation("work");
  const trackWrapRef = useRef(null);
  const [carouselIdx, setCarouselIdx] = useState(0);

  const testimonials = t("testimonials", { returnObjects: true });

  const slideCarousel = (dir) => {
    const wrap = trackWrapRef.current;
    if (!wrap) return;
    const card = wrap.querySelector(".wt-card");
    if (!card) return;
    const step = card.offsetWidth + 16;
    wrap.scrollBy({ left: dir * step, behavior: "smooth" });
    const isMobile = window.innerWidth <= 640;
    const max = isMobile ? testimonials.length - 1 : testimonials.length - 3;
    setCarouselIdx((prev) => Math.max(0, Math.min(prev + dir, max)));
  };

  return (
    <section className="work-section">
      <div className="work-container">

        <header className="work-header">
          <span className="work-eyebrow">{t("eyebrow")}</span>
        </header>

        <div className="marquee-wrapper">
          <div className="marquee-track">
            {[...LOGOS, ...LOGOS].map((logo, i) => (
              <div key={i} className="marquee-item">
                <img src={logo} alt="" className="marquee-logo" loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        <div className="wt-carousel">
          <div className="wt-carousel__header">
            <div className="wt-carousel__nav">
              <button
                className="wt-arrow"
                onClick={() => slideCarousel(-1)}
                disabled={carouselIdx === 0}
                aria-label={t("aria.prev", { ns: "common" })}
              >←</button>
              <button
                className="wt-arrow"
                onClick={() => slideCarousel(1)}
                disabled={carouselIdx >= testimonials.length - 3}
                aria-label={t("aria.next", { ns: "common" })}
              >→</button>
            </div>
          </div>
          <div className="wt-track-wrap" ref={trackWrapRef}>
            <div className="wt-track">
              {testimonials.map((item, i) => (
                <div key={i} className="wt-card">
                  <div className="wt-stars">★★★★★</div>
                  <p className="wt-quote">"{item.quote}"</p>
                  <div className="wt-author">
                    <strong className="wt-name">{item.name}</strong>
                    <span className="wt-role">{item.role}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="work-cta">
          <a href="/contactos" className="work-cta-btn">
            <span>{t("cta")}</span>
          </a>
        </div>

      </div>
    </section>
  );
}
